import React from 'react';

import { returnToShop } from '../../../shopBack';

import './BackButton.css';

interface BackButtonProps {
    athleteSlug: string;
    athleteFirstName: string | null;
}

function resolveBackHref(fallback: string): string {
    if (typeof window === 'undefined') { return fallback; }
    const stored = sessionStorage.getItem('shop-back-url');
    if (!stored) { return fallback; }
    try {
        const parsed = new URL(stored, window.location.href);
        if (parsed.origin !== window.location.origin) { return fallback; }
        return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    } catch {
        return fallback;
    }
}

export function BackButton({ athleteSlug, athleteFirstName }: BackButtonProps) {
    const label = athleteFirstName
        ? `${athleteFirstName}'s Faves`
        : 'Back';
    const fallback = `/@${athleteSlug}`;
    const href = resolveBackHref(fallback);
    return (
        <a
            className="pdp-back"
            href={href}
            onClick={(event) => returnToShop(event, href)}
        >
            <span className="pdp-back__caret" aria-hidden="true">‹</span>
            <span className="pdp-back__label">{label}</span>
        </a>
    );
}
